// Import GLightbox
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

// Inicjalizacja GLightbox dla wszystkich linków do obrazków
document.addEventListener("DOMContentLoaded", function () {
  const lightbox = GLightbox({
    selector:
      'a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"], a[href*=".webp"]',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });
});
